import img from "../assets/images/shutterstock_699442570-min.jpg";
import { useState } from "react";
import constants from "../constants/constants";
import pageSEO from "../constants/pageSEO";
import { SEO } from "../components/seo.component";

export default function Reports() {
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    "Client Type": "",
    "Interested in:": [],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked
        ? [...(prev[name] || []), value]
        : (prev[name] || []).filter((item) => item !== value),
    }));
  };

  async function submitForm(event) {
    event.preventDefault();

    const json = JSON.stringify({
      ...formData,
      access_key: constants.EMAIL_ACCESS_KEY,
      subject: "New Lead Interested in Real Estate Reports",
    });

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    })
      .then((res) => res.json())
      .catch((err) => {
        console.log(err);
      });

    if (res?.success) {
      console.log("Success", res);
      setPopup({
        subject: "Thanks for your message!",
        message: "We will get back to you as soon as possible",
      });
    } else {
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  const seoConfig = pageSEO.reports();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] pt-[150px] mx-auto grid md:grid-cols-2 px-6 gap-x-24 gap-y-10 min-h-[70vh] mb-12">
        <div>
          <h1 className="text-4xl text-black libre">
            Free Real Estate Reports
          </h1>

          <p className="font-semibold text-med-grey my-5">
            Get exclusive buyer & seller real estate reports to help you with
            your next purchase or sale. Get insider tips and tricks, and learn
            how to invest your time and money wisely in the real estate market.
            Just complete the form below, select all the reports you'd like to
            receive and have them emailed to your inbox right away. Get started
            now!
          </p>
          <form onSubmit={submitForm}>
            <div className="form-item">
              <label className="form-label">Name*</label>
              <input
                required
                className="form-input"
                name="Name"
                value={formData.Name}
                onChange={handleInputChange}
                placeholder="Full Name"
              />
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                required
                className="form-input"
                name="Email Address"
                value={formData["Email Address"]}
                onChange={handleInputChange}
                placeholder="Email Address"
              />
            </div>
            <div className="form-item">
              <label className="form-label">I am a*</label>
              <select
                required
                className="form-input"
                name="Client Type"
                value={formData["Client Type"]}
                onChange={handleInputChange}
              >
                <option value="">Please Select</option>
                <option value="Buyer">Buyer</option>
                <option value="Seller">Seller</option>
                <option value="Renter">Renter</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="form-item">
              <label className="form-label">I am interested in:</label>
              <div className="grid grid-cols-2 gap-3 mt-3">
                <div className="cursor-pointer">
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value="Buying guides"
                    type="checkbox"
                    id="1"
                    checked={formData["Interested in:"]?.includes(
                      "Buying guides"
                    )}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="1">Guides for Buying</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value="Selling guides"
                    type="checkbox"
                    id="2"
                    checked={formData["Interested in:"]?.includes(
                      "Selling guides"
                    )}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="2">Guides for Selling</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value="Choosing realtor"
                    type="checkbox"
                    id="3"
                    checked={formData["Interested in:"]?.includes(
                      "Choosing realtor"
                    )}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="3">Choosing a Realtor</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    name="Interested in:"
                    value="Renovations"
                    type="checkbox"
                    id="4"
                    checked={formData["Interested in:"]?.includes(
                      "Renovations"
                    )}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="4">Home Renovations</label>
                </div>
              </div>
            </div>
            <button
              type="submit"
              className="btn-secondary self-start rounded-none px-10 mt-3"
            >
              Submit
            </button>
          </form>
        </div>
        <div className="overflow-hidden h-[600px] ">
          <img
            className="h-full w-full object-cover"
            src={img}
            alt="Real Estate"
          />
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} className="btn-secondary">
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
